var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWindows = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 57,
  height: 57,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m0 8.033 23.115-3.148.01 22.297-23.104.131L0 8.033Zm23.104 21.718.018 22.316L.018 48.89.017 29.601l23.087.15Zm2.803-25.278L56.556 0v26.898l-30.65.244V4.473Zm30.656 25.488-.007 26.777-30.65-4.326-.042-22.502 30.699.05Z",
  fill: "#00ADEF"
})));
export { SvgWindows as ReactComponent };
export default __webpack_public_path__ + "8458bdb2e88be2b0ebece621730f5233.svg";